import { getDeviceCommonName } from '@weenat/client/dist/core/devices'
import { Device } from '@weenat/client/dist/resources/devices'
import { Head } from 'app/routx-router'
import DeviceDashboard from 'app/src/devices/DeviceDashboard'
import withClientDevice from 'app/src/hocs/withClientDevice'
import logEvent from 'app/utils/analytics'
import { useEffect } from 'react'

const DeviceScreen: FC<{ device: Device }> = ({ device }) => {
  const commonName = getDeviceCommonName(device)

  useEffect(() => {
    logEvent('device_summary_page')
  }, [])

  return (
    <>
      <Head title={commonName} />
      <DeviceDashboard device={device} />
    </>
  )
}

export const Component = withClientDevice()(DeviceScreen)
export default Component
